"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyled = void 0;
var dom_1 = require("../../dom");
var useMergeStylesHooks_1 = require("./useMergeStylesHooks");
var useStyled = function (scope) {
    if (scope === void 0) { scope = '__global__'; }
    var _a = (0, useMergeStylesHooks_1.useMergeStylesHooks)(), useAdoptedStylesheetEx = _a.useAdoptedStylesheetEx, useShadowConfig = _a.useShadowConfig, useMergeStylesShadowRootContext = _a.useMergeStylesShadowRootContext, useMergeStylesRootStylesheets = _a.useMergeStylesRootStylesheets, useWindow = _a.useWindow;
    var win = useWindow() || (0, dom_1.getWindow)();
    var shadowCtx = useMergeStylesShadowRootContext();
    var inShadow = !!shadowCtx;
    var rootMergeStyles = useMergeStylesRootStylesheets();
    var shadowConfig = useShadowConfig(scope, inShadow, win);
    useAdoptedStylesheetEx(scope, shadowCtx, rootMergeStyles, win);
    return shadowConfig;
};
exports.useStyled = useStyled;
//# sourceMappingURL=useStyled.js.map